import TabelToolBar from './components/TabelToolBar';
import ListTabel from './components/ListTabel';
export default {
  components: {
    TabelToolBar: TabelToolBar,
    ListTabel: ListTabel
  },
  methods: {
    clearInput: function clearInput() {
      console.log('123123');
      this.$refs.ListTabel.getTabelData();
    }
  }
};